import { render } from "./SongList.vue?vue&type=template&id=16fc8b2d&scoped=true&ts=true"
import script from "./SongList.vue?vue&type=script&lang=ts"
export * from "./SongList.vue?vue&type=script&lang=ts"

import "./SongList.vue?vue&type=style&index=0&id=16fc8b2d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16fc8b2d"]])

export default __exports__